import React, { Component } from 'react';
import ReactSlider from 'react-slider'
import styled from 'styled-components';

class RightSearchBar extends Component {

  render() {

      const StyledSlider = styled(ReactSlider)`
          width: 100%;
          height: 25px;
      `;

      const StyledThumb = styled.div`
          height: 25px;
          line-height: 25px;
          width: 50px;
          text-align: center;
          background-color: #000;
          color: #fff;
          border-radius: 50%;
          cursor: grab;
      `;

      const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;

      const StyledTrack = styled.div`
          top: 0;
          bottom: 0;
          background: ${props => props.index === 2 ? '#0f0' : props.index === 1 ? '#0f0' : '#0f0'};
          border-radius: 999px;
      `;

      const Track = (props, state) => <StyledTrack {...props} index={state.index} />;

      const StyledContainer = styled.div`
          resize: horizontal;
          overflow: auto;
          width: 50%;
          max-width: 100%;
          padding-right: 8px;
      `;




      return (
        <div class="sidebar sidebar-light sidebar-right sidebar-expand-md">

          {/* Sidebar mobile toggler */}
          <div class="sidebar-mobile-toggler text-center">
            <a href="#" class="sidebar-mobile-expand">
              <i class="icon-screen-full"></i>
              <i class="icon-screen-normal"></i>
            </a>
            <span class="font-weight-semibold">Sök</span>
            <a href="#" class="sidebar-mobile-right-toggle">
              <i class="icon-arrow-right8"></i>
            </a>
          </div>
          {/* /sidebar mobile toggler */}


          {/* Sidebar content */}
            <div class="sidebar-content">

                {/* Sidebar search */}
                <div class="card">
                    <div class="card-header bg-transparent border-bottom header-elements-inline">
                        <span class="card-title font-weight-semibold">Sökning</span>

                    </div>
                </div>
                {/* /sidebar search */}

                {this.props.searchCriteria.map(function (section, i) {
                    return <div class={section['pageClass']}>
                        <div class="card-header bg-transparent header-elements-inline">
                            <span class="text-uppercase font-size-sm font-weight-semibold">{section['name']}</span>
                            <div class="header-elements">
                                <div class="list-icons">
                                    <a class="list-icons-item" data-action="collapse"></a>
                                </div>
                            </div>
                        </div>

                        <div class="card-body">
                            {Object.keys(section['fields']).map(function (key) {

                                if (section['fields'][key]['type'] === 'text') {
                                    return <div class="form-group">
                                        <label>{section['fields'][key]['title']}</label>
                                        <input name={key} sectionid={section['id']}
                                               onChange={this.props.updateSearchCriteria}
                                               value={section['fields'][key]['value']}
                                               type={section['fields'][key]['type']} class="form-control"
                                               placeholder={section['fields'][key]['placeholder']}></input>
                                    </div>
                                } else if (section['fields'][key]['type'] === "dropdown") {
                                    return <div class="form-group">
                                        <label>{section['fields'][key]['title']}</label>
                                        <select name={key} sectionid={section['id']}
                                                onChange={this.props.updateSearchCriteria}
                                                value={section['fields'][key]['value']} class="form-control">
                                            {
                                                Object.keys(section['fields'][key]['options']).map(function (optionKey) {
                                                    return <option
                                                        value={section['fields'][key]['options'][optionKey]['value']}>{section['fields'][key]['options'][optionKey]['name']}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                } else if (section['fields'][key]['type'] === "checkbox") {
                                    return <div class="form-group form-check">
                                        <input name={key} sectionid={section['id']}
                                               onChange={this.props.updateSearchCriteria}
                                               checked={section['fields'][key]['value']} type="checkbox"
                                               class="form-check-input"/>
                                        <label class="form-check-label"> {section['fields'][key]['title']}</label>
                                    </div>
                                } else if (section['fields'][key]['type'] === "single-slider") {
                                    return <div class="form-group">
                                        <label>{section['fields'][key]['title']}</label>
                                        <StyledSlider
                                            renderTrack={Track}
                                            renderThumb={Thumb}
                                            min="3"
                                            max="3500"
                                        />
                                    </div>
                                } else if (section['fields'][key]['type'] === "min-max-slider") {
                                    return <div class="form-group">
                                        <label>{section['fields'][key]['title']}</label>
                                        <StyledSlider
                                            defaultValue={[50, 75]}
                                            renderTrack={Track}
                                            renderThumb={Thumb}
                                        />
                                    </div>
                                }


                            }, this)}
                        </div>
                    </div>
                }, this)}
                <div style={{paddingLeft: '20px'}}>
                    {this.props.colorMapping && this.props.colorMapping.map((section, i) => {
                        const roundedThreshold = Math.round(section.threshold);
                        return (
                            <div key={i} style={{display: 'flex', alignItems: 'center', marginBottom: '5px'}}>
                                <div style={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: section.color,
                                    marginRight: '10px'
                                }}></div>
                                <span>{roundedThreshold}</span>
                            </div>
                        );
                    })}
                </div>
                {/* search buttin */}
                <div class="card-body">
                    <div class="col-12">
                        <button onClick={this.props.searchFunction} class="btn btn-success btn-block">Sök</button>
                    </div>
                </div>
                {/* /search buttin */}

            </div>
            {/* /sidebar content */}

        </div>
      )
  }
}

export default RightSearchBar;
